//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const TYPES = [
    {
        name: '市内全域迁移',
    },
    {
        name: '市外户口迁入',
        date: '2022.1.7更新'
    }
]
export default {
    data () {
        return {
            types: TYPES
        }
    },
    methods: {
        start (e) {
            const { type } = e.currentTarget.dataset
            this.$emit('start', type)
        }
    }
}
